import { isUrlWhitelisted } from "@jti/fe-common";
import { useConfig } from "../../providers/useConfig";
import { useQueryStringParams } from "../useQueryStringParams";
export const useWhitelistedReturnUrl = () => {
    const { returnUrl } = useQueryStringParams();
    const { whitelistedDomains } = useConfig();
    if (!returnUrl || typeof returnUrl !== "string" || !isUrlWhitelisted(returnUrl, whitelistedDomains)) {
        return { returnUrl: undefined };
    }
    return { returnUrl };
};
//# sourceMappingURL=useWhitelistedReturnUrl.js.map